<script setup>
import { defineComponent } from "vue";

defineProps({
    value: String,
});

defineComponent({
    name: "JetLabel",
});
</script>

<template>
    <label class="block font-medium my-1 text-gray-900" :class="{ 'text-sm': !$attrs.class }">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>
    </label>
</template>
